<template>
    <div>
        <div class="card-body text-center">
            <h4><i class="fas fas fa-hourglass-half"></i>&nbsp;Waiting for buyer to pay trade amount.</h4>
        </div>
        <div class="card-body text-center">
            <p class="text-center aboutscroll">
                After payment of trade amount, you may begin shipping the merchandise.
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PayPending"
    }
</script>

<style scoped>

</style>
